'use client';

import React, { useEffect, useState, useRef } from 'react';
import { ClipboardMinus, Printer, Trash2, File, SearchIcon } from 'lucide-react';
import { Card, Button, Table, Label, Input } from 'reactstrap';
import { Tooltip } from "react-tooltip";
import { useNavigate } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import InvoiceReceipt from './InvoiceReceipt';
import { useTranslation } from 'react-i18next';
import { cancelTestOrder, getTestOrder } from './service/report-test-service';
import { useLoader } from '../../_helper/LoaderContext';
import MyPagination from '../pagination';
import { useCurrency } from "../../_helper/currencyContext";
import { useLab } from "../../_helper/PharmacyProvider";
import { formatDoctorDisplayDateTime } from "../../utils/dateTime/dateFormat";
import { getLabTax } from "../../utils/taxConfig";
import ReportList from './ReportList';
import Payment from '../ladger/Payment';
import { getInvoiceDetail } from '../ladger/service/ledger-service';
import { toast } from 'react-toastify';
import { FormLabel } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { masterDoctor } from '../SearchPatient/services/search-patient';
import SearchFilterButtons from '../SearchFilterButtons';
import CollectSamplesModal from './CollectSamplesModal';

export default function TestHome() {
    const { t } = useTranslation()
    const [show, setShow] = useState(false);
    const [showResult, setShowResult] = useState(false);
    const handleClose = () => setShow(false);
    const handleCloseResult = () => setShowResult(false);
    const [customerType, setCustomerType] = useState('all');
    const [patients, setPatients] = useState([]);
    const navigate = useNavigate();
    const [search, setSearch] = useState("");
    const [appliedSearch, setAppliedSearch] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [reportStatus, setReportStatus] = useState("");
    const [appliedReportStatus, setAppliedReportStatus] = useState("");
    const [paymentStatus, setPaymentStatus] = useState("");
    const [entriesPerPage, setEntriesPerPage] = useState(10);
    const [totalEntries, setTotalEntries] = useState(0);
    const { setLoading } = useLoader();
    const [showTests, setShowTests] = useState(null);
    const { getCurrencySymbol } = useCurrency();
    const { currentLab } = useLab();
    const taxLabel = getLabTax(currentLab).label;
    const [data, setData] = useState({})
    const [trData, setTrData] = useState({})
    const [doctor, setDoctor] = useState([])
    const [selectedDoctor, setSelectedDoctor] = useState("");
    const [appliedDoctor, setAppliedDoctor] = useState("");
    const [selectedDoctorId, setSelectedDoctorId] = useState("");
    const [doctorSearch, setDoctorSearch] = useState("");
    const [isDoctorOpen, setIsDoctorOpen] = useState(false);
    const doctorDropdownRef = useRef(null);

    const getDoctorDisplayName = (doc) => {
        if (!doc) return "";
        return (doc.name || `${doc.fname || ""} ${doc.lname || ""}`).trim();
    };

    const selectedDoctorOption = doctor.find(
        (d) => d._id === selectedDoctorId || getDoctorDisplayName(d) === selectedDoctor
    );

    const availableDoctors = doctor.filter((d) => {
        const name = getDoctorDisplayName(d).toLowerCase();
        return name.includes(doctorSearch.toLowerCase().trim());
    });

    const handleDoctorSelect = (d) => {
        const docName = getDoctorDisplayName(d);
        setSelectedDoctorId(d._id);
        setSelectedDoctor(docName);
        setDoctorSearch("");
        setIsDoctorOpen(false);
    };

    const handleClearDoctor = (e) => {
        e.stopPropagation();
        setSelectedDoctorId("");
        setSelectedDoctor("");
        setDoctorSearch("");
    };

    useEffect(() => {
        const clickOutside = (e) => {
            if (doctorDropdownRef.current && !doctorDropdownRef.current.contains(e.target)) {
                setIsDoctorOpen(false);
            }
        };
        document.addEventListener("mousedown", clickOutside);
        return () => document.removeEventListener("mousedown", clickOutside);
    }, []);

    const [showCollectSamples, setShowCollectSamples] = useState(false);
    const [collectOrder, setCollectOrder] = useState(null);

    const openCollectSamples = (order) => {
        setCollectOrder(order);
        setShowCollectSamples(true);
    };

    const closeCollectSamples = () => {
        setShowCollectSamples(false);
        setCollectOrder(null);
    };
    useEffect(() => {
        getList()
    }, [currentPage, entriesPerPage])

    const getList = async (
        query = appliedSearch,
        statusFilter = appliedReportStatus,
        doctorFilter = appliedDoctor
    ) => {
        setLoading(true)
        try {
            const form_data = new FormData()
            form_data.append("search", query);
            form_data.append("page", currentPage);
            form_data.append("limit", entriesPerPage);
            form_data.append("doctorName", doctorFilter);
            if (statusFilter) {
                form_data.append("status", statusFilter);
            }
            if (paymentStatus === "paid") {
                form_data.append("isPaid", true);
            }
            else if (paymentStatus === "partial") {
                form_data.append("isPartialPaid", true);
            }
            const res = await getTestOrder(form_data)
            // console.log(res)
            if (res.data.success == true) {
                setPatients(res.data.data.testOrders)
                setTotalEntries(res.data.data.pagination.totalItems || 0);
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        getMasterDoctor()
    }, [])

    const getMasterDoctor = async () => {
        setLoading(true);
        try {
            const res = await masterDoctor();
            if (res.data.success) setDoctor(res.data.data);
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };


    const totalPages = Math.ceil(totalEntries / entriesPerPage);

    const openModel = async (data) => {
        // console.log(data)
        setLoading(true)
        try {
            const res = await getInvoiceDetail(data._id);
            if (res.data.success == true) {
                setTrData(res.data.data)
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
        setShow(true)
    }

    const openResult = (row) => {
        setData(row)
        setShowResult(true)
    }

    const handleSearch = () => {
        const query = search.trim();
        setAppliedSearch(query);
        setAppliedReportStatus(reportStatus);
        setAppliedDoctor(selectedDoctor);
        if (currentPage === 1) {
            getList(query, reportStatus, selectedDoctor);
        } else {
            setCurrentPage(1);
        }
    };

    const handleClear = () => {
        setSearch("");
        setReportStatus("");
        setSelectedDoctor("");
        setSelectedDoctorId("");
        setDoctorSearch("");
        setIsDoctorOpen(false);
        const hadFilter = Boolean(appliedSearch || appliedReportStatus || appliedDoctor);
        setAppliedSearch("");
        setAppliedReportStatus("");
        setAppliedDoctor("");
        if (!hadFilter) return;
        if (currentPage === 1) {
            getList("", "", "");
        } else {
            setCurrentPage(1);
        }
    };

    const cancelOrder = async (data) => {

        Swal.fire({
            title: t("Are you sure?"),
            text: `${t("You want to cancel this test?")} ${getCurrencySymbol(data.payment?.currency)}${Number(data.payment.paid).toFixed(2)} ${t("amount will be refund")}`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: t("Yes, Cancel it!")
        }).then(async (result) => {
            if (result.isConfirmed) {
                setLoading(true)
                try {
                    const res = await cancelTestOrder(data._id)
                    if (res.data.success == true) {
                        toast.success(res.data.message);
                        getList()
                    }
                } catch (error) {
                    console.log(error);
                } finally {
                    setLoading(false)
                }
            }
        });

    }

    const handlePageSizeChange = (e) => {
        const newSize = Number(e.target.value);
        setEntriesPerPage(newSize);  // Use the correct setter
        setCurrentPage(1);           // Reset to page 1
    }

    const getStartingSerialNumber = () => {
        return (currentPage - 1) * entriesPerPage + 1;
    };

    return (
        <>
            <Card>
                <div className="p-3 mt-4">
                    <div className="tw-max-w-full tw-mx-auto">
                        <div className="d-flex align-items-center flex-wrap gap-2 mb-4">
                            <div className="input-group" style={{ flex: "2.2 1 340px", minWidth: 260, height: 42 }}>
                                <span className="input-group-text tw-bg-white" id="basic-addon1" style={{ height: 42 }}><SearchIcon /></span>
                                <input
                                    type="text"
                                    className="form-control icon_form"
                                    placeholder={t("Search By Patient Name and Doctor")}
                                    aria-label={t("Search By Patient Name and Doctor")}
                                    aria-describedby="basic-addon1"
                                    style={{ borderLeft: 'none', height: 42 }}
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") handleSearch();
                                    }}
                                />
                            </div>
                            <select
                                className="form-select"
                                aria-label={t("Report Status")}
                                style={{ flex: "0 1 220px", minWidth: 170, width: 220, height: 42 }}
                                value={reportStatus}
                                onChange={(e) => setReportStatus(e.target.value)}
                            >
                                <option value="">{t("Report Status")}</option>
                                <option value="Ordered">{t("Ordered")}</option>
                                <option value="Completed">{t("Completed")}</option>
                                <option value="cancelled">{t("Cancelled")}</option>
                            </select>
                            <div
                                className="position-relative"
                                ref={doctorDropdownRef}
                                style={{ flex: "0 1 220px", minWidth: 170, width: 220 }}
                            >
                                <button
                                    type="button"
                                    className="form-select text-start d-flex align-items-center justify-content-between"
                                    style={{ height: 42 }}
                                    onClick={() => setIsDoctorOpen(!isDoctorOpen)}
                                    aria-label={t("Select Doctor")}
                                >
                                    <span
                                        className={selectedDoctorOption ? "" : "text-muted"}
                                        style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                                    >
                                        {selectedDoctorOption
                                            ? getDoctorDisplayName(selectedDoctorOption)
                                            : t("Search doctor...")}
                                    </span>
                                    {selectedDoctorOption && (
                                        <span
                                            role="button"
                                            className="ms-2 text-muted"
                                            style={{ cursor: "pointer", lineHeight: 1 }}
                                            onClick={handleClearDoctor}
                                            title={t("Clear")}
                                        >
                                            ×
                                        </span>
                                    )}
                                </button>
                                {isDoctorOpen && (
                                    <div
                                        className="position-absolute bg-white text-black border rounded shadow w-100 mt-1"
                                        style={{ zIndex: 1050, maxHeight: "230px", overflowY: "auto" }}
                                    >
                                        <div className="p-2 border-bottom">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder={t("Search...")}
                                                value={doctorSearch}
                                                onChange={(e) => setDoctorSearch(e.target.value)}
                                                onKeyDown={(e) => e.stopPropagation()}
                                                autoFocus
                                            />
                                        </div>
                                        {availableDoctors.length > 0 ? (
                                            availableDoctors.map((d) => (
                                                <div
                                                    key={d._id}
                                                    className="dropdown-item py-2 px-3"
                                                    style={{
                                                        cursor: "pointer",
                                                        backgroundColor:
                                                            (selectedDoctorOption?._id === d._id)
                                                                ? "rgba(27, 37, 91, 0.08)"
                                                                : undefined,
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        whiteSpace: "nowrap",
                                                    }}
                                                    onClick={() => handleDoctorSelect(d)}
                                                >
                                                    {getDoctorDisplayName(d)}
                                                </div>
                                            ))
                                        ) : (
                                            <div className="px-3 py-2 text-muted">{t("No results")}</div>
                                        )}
                                    </div>
                                )}
                            </div>
                            <div className="flex-shrink-0">
                                <SearchFilterButtons onSearch={handleSearch} onClear={handleClear} height={42} />
                            </div>
                        </div>
                        <div className="recent-table table-responsive currency-table tw-rounded-lg tw-border tw-border-black custom-slim-scrollbar"
                        >
                            <Table className="mb-0 table-center table-bordered table-hover doctor-table" style={{ tableLayout: "fixed", overflowX: 'auto' }}>
                                <thead>
                                    <tr>
                                        <th className="text-center bg-primary tw-text-center" style={{
                                            width: "50px"
                                        }}>
                                            <b>#</b>
                                        </th>
                                        <th className="bg-primary text-white text-left tw-sticky tw-left-0" style={{ width: '150px', zIndex: 3 }}><b>{t("Patient Name")}</b></th>
                                        <th className="bg-primary text-white text-left" style={{ width: '145px' }}><b>{t("Rf. Doctor")}</b></th>
                                        <th className="bg-primary text-white text-left" style={{ width: '125px' }}><b>{t("Lab User")}</b></th>
                                        <th className="bg-primary text-white text-left" style={{ width: '140px' }}><b>{t("Tests")}</b></th>
                                        <th className="bg-primary text-white text-center" style={{ width: '105px' }}><b>{t("Taxable Amt")}</b></th>
                                        {/* <th className="bg-primary text-white text-center" style={{ width: '130px' }}><b>Discount (%)</b></th> */}
                                        <th className="bg-primary text-white text-center" style={{ width: '105px' }}><b>{t("Discount Amt")}</b></th>
                                        {/* <th className="bg-primary text-white text-center" style={{ width: '130px' }}><b>Tax %</b></th> */}
                                        <th className="bg-primary text-white text-center" style={{ width: '105px' }}><b>{taxLabel} {t("Amt")}</b></th>
                                        <th className="bg-primary text-white text-center" style={{ width: '105px' }}><b>{t("Total Amt")}</b></th>
                                        <th className="bg-primary text-white text-center" style={{ width: '95px' }}><b>{t("Paid")}</b></th>
                                        <th className="bg-primary text-white text-center" style={{ width: '160px' }}><b>{t("Date")}</b></th>
                                        <th className="bg-primary text-white text-center" style={{ width: '100px' }}><b>{t("Report")}</b></th>
                                        <th className="bg-primary text-white text-center" style={{ width: '150px' }}><b>{t("Action")}</b></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {patients.length > 0 ? (
                                        patients.map((patient, index) => {
                                            const serialNumber = getStartingSerialNumber() + index;
                                            return (
                                                <tr key={patient._id} className={index % 2 === 0 ? '' : ''}>

                                                    <td className="text-center font-weight-bold">
                                                        {serialNumber}
                                                    </td>
                                                    {/* Patient Name */}
                                                    <td className="tw-sticky tw-left-0" style={{ backgroundColor: 'var(--bs-table-bg, #fff)', overflow: 'visible', zIndex: 2 }}>
                                                        <div
                                                            className="tw-font-medium" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                                                            data-tooltip-id={`cname-tooltip-${patient.patient.name}`}
                                                            data-tooltip-content={patient.patient.name}
                                                        >
                                                            {patient.patient.name}
                                                        </div>
                                                        <Tooltip id={`cname-tooltip-${patient.patient.name}`} place="top" />
                                                    </td>

                                                    {/* Doctor */}
                                                    <td>
                                                        <div className="tw-font-medium" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                            <span
                                                                data-tooltip-id="doctor-tooltip"
                                                                data-tooltip-content={patient.doctor?.name}
                                                            >
                                                                {patient.doctor?.name || "-"}
                                                            </span>
                                                            <Tooltip id="doctor-tooltip" place="top" />

                                                        </div>
                                                    </td>

                                                    {/* Lab user */}
                                                    <td>
                                                        <div
                                                            className="tw-font-medium" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                                                            data-tooltip-id={`cname-tooltip-${patient.createdBy.name}`}
                                                            data-tooltip-content={patient.createdBy.name}
                                                        >
                                                            {patient.createdBy.name || "-"}
                                                        </div>
                                                        <Tooltip id={`cname-tooltip-${patient.createdBy.name}`} place="top" />
                                                    </td>
                                                    {/* Tests */}
                                                    <td>
                                                        <div className="tw-flex tw-items-center tw-gap-2">
                                                            <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block' }}>
                                                                {patient.allTests[0].name}
                                                            </span>
                                                            {patient.allTests.length > 1 && (
                                                                <span
                                                                    className="tw-text-blue-600 tw-underline tw-cursor-pointer tw-shrink-0"
                                                                    onClick={() => setShowTests(patient._id)}
                                                                >
                                                                    +{patient.allTests.length - 1}
                                                                </span>
                                                            )}
                                                        </div>

                                                        {/* Modal for more tests */}
                                                        {showTests === patient._id && (
                                                            <div className="tw-fixed tw-inset-0 tw-bg-black/40 tw-z-50 tw-flex tw-items-center tw-justify-center" onClick={() => setShowTests(null)}>
                                                                <div className="tw-bg-white tw-rounded-lg tw-p-6 tw-max-w-md tw-w-full tw-shadow-2xl" onClick={e => e.stopPropagation()}>

                                                                    <ul className="tw-space-y-2 tw-max-h-96 tw-overflow-y-auto">
                                                                        {patient.allTests.map((t, i) => (
                                                                            <li key={i} className="tw-py-2 tw-px-3 tw-bg-gray-50 tw-rounded" style={{ color: 'black' }}>
                                                                                {t.name}
                                                                            </li>
                                                                        ))}
                                                                    </ul>
                                                                    <button
                                                                        className="tw-mt-4 tw-w-full btn btn-secondary"
                                                                        onClick={() => setShowTests(null)}
                                                                    >
                                                                        {t("Close")}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </td>



                                                    {/* Taxable Total */}
                                                    <td className="text-center" style={{ whiteSpace: "nowrap" }}>
                                                        <span className="tw-font-bold text-success">
                                                            {getCurrencySymbol(patient.payment?.currency)}{Number(patient.payment.totalPrice).toFixed(2)}
                                                        </span>
                                                    </td>
                                                    {/* Discount % */}
                                                    {/* <td className="tw-px-3 tw-py-3 text-center">
                                                        <span className="tw-font-bold">
                                                            {patient.payment.discount.percentage > 0 ? (
                                                                <div className="">
                                                                    {patient.payment.discount.percentage}%
                                                                </div>
                                                            ) : (
                                                                <div className=""> - </div>
                                                            )}
                                                        </span>
                                                    </td> */}
                                                    {/* Discount Amount */}
                                                    <td className="text-center" style={{ whiteSpace: "nowrap" }}>
                                                        <span className="tw-font-bold ">
                                                            {patient.payment.discount.amount > 0.0 ? (
                                                                <div className="">
                                                                    {getCurrencySymbol(patient.payment?.currency)}{Number(patient.payment.discount.amount).toFixed(2)}
                                                                </div>
                                                            ) : (
                                                                <div className=""> - </div>
                                                            )}
                                                        </span>
                                                    </td>

                                                    {/* Tax % */}
                                                    {/* <td className="tw-px-3 tw-py-3 text-center">
                                                        <span className="tw-font-bold text-success">
                                                            {Number(patient.payment.IGSTPercentage)}%
                                                        </span>
                                                    </td> */}

                                                    {/* IGST Amount */}
                                                    <td className="text-center" style={{ whiteSpace: "nowrap" }}>
                                                        <span className="tw-font-bold text-success">
                                                            {getCurrencySymbol(patient.payment?.currency)}{Number(patient.payment.IGST).toFixed(2)}
                                                        </span>
                                                    </td>

                                                    {/* Total Amount */}
                                                    <td className="text-center" style={{ whiteSpace: "nowrap" }}>
                                                        <span className="tw-font-bold text-success">
                                                            {getCurrencySymbol(patient.payment?.currency)}{Number(patient.payment.netTotal).toFixed(2)}
                                                        </span>
                                                    </td>

                                                    {/* Paid */}
                                                    <td className="text-center" style={{ whiteSpace: "nowrap" }}>
                                                        <span className="tw-font-bold">
                                                            {getCurrencySymbol(patient.payment?.currency)}{Number(patient.payment.paid).toFixed(2)}
                                                        </span>
                                                    </td>

                                                    {/* Date & Time */}
                                                    <td className="text-center tw-text-xs" style={{ whiteSpace: "nowrap" }}>
                                                        {formatDoctorDisplayDateTime(patient.createdAt, currentLab) || "-"}
                                                    </td>

                                                    {/* Report Status */}
                                                    <td className="text-center" style={{ whiteSpace: "nowrap" }}>
                                                        {patient.status === "Completed" ? (
                                                            <span className="tw-font-bold tw-text-green-700">{t("Completed")}</span>
                                                        ) : patient.status === "cancelled" ? (
                                                            <span className="tw-font-bold tw-text-red-700">{t("Cancelled")}</span>
                                                        ) : patient.status === "Ordered" ? (
                                                            <span className="tw-font-bold tw-text-purple-700">{t("Ordered")}</span>
                                                        ) : null}
                                                    </td>

                                                    {/* Actions */}
                                                    <td className="text-center">
                                                        <div className="d-inline-flex align-items-center justify-content-center">
                                                            {patient.status !== "cancelled" && (
                                                                patient.status !== "Completed" ? (
                                                                    <>
                                                                        <Tooltip id="fileTip" place="top" content={t("Add Test Result")} />
                                                                        <button className='success-action-mutted me-1' data-tooltip-id="fileTip" onClick={() => navigate(`${process.env.PUBLIC_URL}/Add-test_result/${patient._id}`)}>
                                                                            <i className="bi bi-journal-arrow-up" style={{ fontSize: "18px" }}></i>
                                                                        </button>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <Tooltip id="pdf" place="top" content={t("View Test Result")} />
                                                                        <button className='success-action-button me-1' data-tooltip-id="pdf" onClick={() => openResult(patient)}>
                                                                            <i className="bi bi-journal-arrow-down" style={{ fontSize: "18px" }}></i>
                                                                        </button></>
                                                                )
                                                            )}

                                                            {patient.status !== "cancelled" && patient.status !== "Completed" && (
                                                                <>
                                                                    <Tooltip id="sampleCollection" place="top" content={t("Sample Collection")} />
                                                                    <button
                                                                        className='success-action-button me-1'
                                                                        data-tooltip-id="sampleCollection"
                                                                        onClick={() => openCollectSamples(patient)}
                                                                    >
                                                                        <i className="bi bi-droplet-half" style={{ fontSize: "18px" }}></i>
                                                                    </button>
                                                                    {/* Sample collection page — open from Collected Sample list later
                                                                    <button
                                                                        className='success-action-button me-1'
                                                                        data-tooltip-id="sampleCollection"
                                                                        onClick={() => navigate(`${process.env.PUBLIC_URL}/sample-collection/${patient._id}`)}
                                                                    >
                                                                        <i className="bi bi-droplet-half" style={{ fontSize: "18px" }}></i>
                                                                    </button>
                                                                    */}
                                                                </>
                                                            )}

                                                            <Tooltip id="invoice" place="top" content={t("View Invoice")} />
                                                            <button className='success-action-button me-1' data-tooltip-id="invoice" onClick={() => openModel(patient)} >
                                                                <i className="bi bi-receipt" style={{ fontSize: "18px" }}></i>
                                                            </button>

                                                            {patient.status !== "Completed" && patient.status !== "cancelled" && (
                                                                <>
                                                                    <Tooltip id="cancel" place="top" content={t("Cancel Test Order")} />
                                                                    <button className='danger-action-button me-1' data-tooltip-id="cancel" onClick={() => cancelOrder(patient)} >
                                                                        <i className="bi bi-x-octagon-fill" style={{ fontSize: "18px" }}></i>
                                                                    </button>
                                                                </>
                                                            )}
                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                        )
                                    ) : (
                                        <tr>
                                            <td
                                                colSpan={13}
                                                className="text-center py-4 text-muted"
                                            >
                                                {t("No data available")}
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                        <div className="d-md-flex align-items-center text-center justify-content-between mt-3 mb-3">
                            <div className="show-entries">
                                <FormLabel>{t("Show")}&nbsp;</FormLabel>
                                <select style={{ display: 'unset', width: 'auto', padding: '0.375rem 2.25rem 0.375rem 0.75rem' }} value={entriesPerPage}
                                    onChange={handlePageSizeChange} className="form-control">
                                    <option value={5}>5</option>
                                    <option value={10}>10</option>
                                    <option value={30}>30</option>
                                    <option value={20}>20</option>
                                    <option value={50}>50</option>
                                </select>&nbsp;
                                <FormLabel>{t("entries")}</FormLabel>
                            </div>
                            <MyPagination totalPages={totalPages} currentPage={currentPage} onPageChange={(page) => setCurrentPage(page)} />
                        </div>
                        {/* <div className="mt-3">

                            <MyPagination totalPages={totalPages}
                                currentPage={currentPage}
                                onPageChange={(page) => setCurrentPage(page)}></MyPagination>
                        </div> */}
                    </div>
                </div>
            </Card>
            {/* <Modal show={show} onHide={handleClose}> */}
            <Payment show={show} onHide={handleClose} trData={trData} />
            {/* <InvoiceReceipt setUploadModelOpen={handleClose} toggleUploadModel={handleClose} /> */}
            {/* </Modal> */}
            <Modal show={showResult} onHide={handleCloseResult} centered scrollable>
                <ReportList setUploadModelOpen={handleCloseResult} toggleUploadModel={handleCloseResult} data={data} />
            </Modal>

            <CollectSamplesModal
                show={showCollectSamples}
                onHide={closeCollectSamples}
                order={collectOrder}
                onSuccess={() => getList()}
            />

        </>
    );
}